module.exports = __webpack_public_path__ + "static/media/Firestore.927c1522.png";